import { render } from "./PedagogicCard.component.vue?vue&type=template&id=496111a2"
import script from "./PedagogicCard.component.vue?vue&type=script&lang=js"
export * from "./PedagogicCard.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/PedagogicCard.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "496111a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('496111a2', __exports__)) {
    console.log('reload')
    api.reload('496111a2', __exports__)
  }
  
  module.hot.accept("./PedagogicCard.component.vue?vue&type=template&id=496111a2", () => {
    console.log('re-render')
    api.rerender('496111a2', render)
  })

}


export default __exports__